var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_4281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 9.33325L12.7072 7.92253C11.6891 7.18948 10.2977 7.26524 9.3652 8.1045L6.63464 10.562C5.70213 11.4013 4.31072 11.477 3.29259 10.744L1.33325 9.33325M3.99992 14.6666H11.9999C13.4727 14.6666 14.6666 13.4727 14.6666 11.9999V3.99992C14.6666 2.52716 13.4727 1.33325 11.9999 1.33325H3.99992C2.52716 1.33325 1.33325 2.52716 1.33325 3.99992V11.9999C1.33325 13.4727 2.52716 14.6666 3.99992 14.6666ZM7.33325 5.66659C7.33325 6.58706 6.58706 7.33325 5.66659 7.33325C4.74611 7.33325 3.99992 6.58706 3.99992 5.66659C3.99992 4.74611 4.74611 3.99992 5.66659 3.99992C6.58706 3.99992 7.33325 4.74611 7.33325 5.66659Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_4281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabImage);
export default __webpack_public_path__ + "static/media/tab-image.be774630f56f61af04e3d6d5bbcc1a60.svg";
export { ForwardRef as ReactComponent };